<template lang="pug">
v-content
  v-toolbar.page-header(app, flat, fixed, color='white', height='105')
    v-breadcrumbs(divider='/')
      v-breadcrumbs-item
        router-link(to='/organizations')
          h2 All Organizations
      v-breadcrumbs-item(v-if='!this.$route.params.id' disabled='')
        h2.ma-0 Add Organization
      v-breadcrumbs-item(v-if='this.$route.params.id')
        router-link(:to="`/organizations/organization/${this.$route.params.id}`")
          h2.ma-0
            | {{ C.data.organization.name }}
      v-breadcrumbs-item(v-if='this.$route.params.id' disabled='')
        h2.ma-0 Edit

  v-container.pa-0(fluid, grid-list-lg)
    v-layout(row, nowrap)
      v-flex.pr-4
        template
          v-form(v-model='C.form.validation.overall', ref='form', lazy-validation)
            .pb-5
              .section__title.mb-5
                .subheading
                  | Organization Info
              v-layout(row)
                v-flex(md3)
                  label.pl-0 Name
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.organization.name', :rules='C.form.validation.rules.organization.name', single-line, required)

            .pb-5
              .section__title.mb-5
                .subheading
                  | Business Address
              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 Street Address
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.organization.business_address.street1')

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 Street Address (cont.)
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.organization.business_address.street2')

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 City
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.organization.business_address.city')

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 State/Province
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.organization.business_address.state_province')

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 Country
                v-flex(md6)
                  v-select.input--box.pt-0(v-model='C.form.selected.organization.business_address.country', :items='C.form.list.countries', item-text='name', item-value='alpha3')

        v-divider.my-3
        v-layout(row)
          v-flex(md3)
          v-flex(md6)
            v-btn.ml-0(@click='C.form.trigger.submit', :disabled='!C.form.validation.overall', color='primary')
              | {{ this.$route.params.id ? "Update" : "Add" }}
            v-btn(to='/organizations', exact, v-if='!this.$route.params.id')
              | Cancel
            v-btn(:to="`/organizations/organization/${this.$route.params.id}`", exact, v-if='this.$route.params.id')
                | Cancel



</template>

<script>
  import SideDrawer from '@/components/SideDrawer'
  import globalSettings from '../../assets/global-settings.js'
  import tools from '../../assets/tools.js'
  import axios from '../../../node_modules/axios/dist/axios.js'
  import countryData from 'country-data'

  export default {
    components: {
      'side-drawer': SideDrawer
    },
    computed: {
      binding () {
        const binding = {}
        if (this.$vuetify.breakpoint.smAndDown) binding.column = true
        return binding
      }
    },
    data () {
      return {
        sideDrawer: {
          model: null,
          mini: false
        },
        sideItems: [
          { icon: 'home', text: 'Home', link: '' },
          { icon: 'lightbulb_outline', text: 'Inventions', link: '' },
          { icon: 'people', text: 'People', link: '/people' },
          { icon: 'work', text: 'Organizations', link: '' }
        ],
        CR: {
          show: globalSettings.show
        },
        C: {
          data: {
            organization: {}
          },
          form: {
            validation: {
              overall: false,
              rules: {
                organization: {
                  name: [
                    (v) => !!v || 'Name is required'
                  ]
                }
              }
            },
            selected: {
              organization: {
                name: '',
                business_address: {
                  street1: '',
                  street2: '',
                  city: '',
                  state_province: '',
                  country: 'USA'
                }
              }
            },
            list: {
              countries: countryData.countries.all
            },
            trigger: {
              submit: () => {
                var component = this

                var submitItem = {
                  name: component.C.form.selected.organization.name,
                  business_address: component.C.form.selected.organization.business_address
                }

                var apiCallPromise

                if (component.$route.params.id) {
                  submitItem.organization_id = component.$route.params.id

                  apiCallPromise = axios.put(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/organizations/update`, submitItem)
                } else {
                  apiCallPromise = axios.post(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/organizations/create`, submitItem)
                }

                apiCallPromise
                  .then(function (response) {
                    console.info('Manage Organization Results: ', response.data)

                    if (component.$route.params.id) {
                      component.$router.push({
                        name: 'Organization',
                        params: {
                          id: component.$route.params.id
                        }
                      })
                    } else {
                      component.$router.push({
                        name: 'Organizations'
                      })
                    }

                    tools.alert({
                      type: 'success',
                      message: `${component.C.form.selected.organization.name} has been saved.`
                    })
                  })
                  .catch(function (errorResponse) {
                    tools.alert({
                      type: 'error',
                      errorResponse: errorResponse
                    })
                  })
              }
            }
          }
        }
      }
    },
    created () {
      var component = this

      if (this.$route.params.id) {
        tools.getOrganization({
          id: this.$route.params.id,
          success: function (organizationData) {
            component.C.data.organization = organizationData

            component.C.form.selected.organization.name = organizationData.name
            component.C.form.selected.organization.business_address = organizationData.business_address || {}

            component.C.form.selected.organization.business_address.country = component.C.form.selected.organization.business_address.country || 'USA'
          }
        })
      }
    }
  }
</script>


<style scoped>
  .side-drawer {
    background-color: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/components/Organizations/Add.vue